var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrystalBall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.683,38.32c0-5.137,4.18-9.317,9.317-9.317c1.104,0,2-0.896,2-2s-0.896-2-2-2c-7.343,0-13.317,5.974-13.317,13.317 c0,1.104,0.896,2,2,2S38.683,39.424,38.683,38.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,57.459c10.553,0,19.139-8.586,19.139-19.139S58.553,19.181,48,19.181c-10.553,0-19.139,8.586-19.139,19.139 S37.447,57.459,48,57.459z M48,23.181c8.348,0,15.139,6.792,15.139,15.139S56.348,53.459,48,53.459S32.861,46.667,32.861,38.32 S39.652,23.181,48,23.181z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.477,59.204c-0.189-0.521-0.587-0.941-1.098-1.158c-0.511-0.218-1.09-0.213-1.597,0.015 c-5.556,2.477-12.008,2.477-17.564,0c-0.508-0.228-1.084-0.232-1.596-0.015c-0.511,0.217-0.909,0.637-1.098,1.158l-5.418,14.933 c-0.223,0.613-0.132,1.297,0.242,1.831c0.375,0.533,0.985,0.852,1.638,0.852h30.029c0.652,0,1.264-0.318,1.638-0.852 c0.374-0.534,0.465-1.218,0.242-1.831L59.477,59.204z M35.838,72.819l3.743-10.314c5.403,1.889,11.436,1.889,16.838,0l3.742,10.314 H35.838z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalBall);
export default __webpack_public_path__ + "static/media/crystal-ball.3343b0bd4cc5361fb2a7b24aff108c4c.svg";
export { ForwardRef as ReactComponent };